import styled from 'styled-components';

export const GasIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-right: 4px;
  opacity: ${props => (props.isDisabled ? 0.4 : 1)};
`;
